import _         from 'lodash';
import moment    from 'moment';
import Immutable from 'immutable';

import { dateFormat } from 'alto-utils/lib/utils';

import CanteenMenu         from './canteen_menu';
import DailyMenuWithOrders from './daily_menu_with_orders';

export default class CanteenMenuWithOrders extends CanteenMenu {
  dailyMenuFor(date) {
    const groupMenus = this._dailyMenus?.get(date.format(dateFormat)) ?? null;

    return new DailyMenuWithOrders(this.canteen, date, groupMenus, this._menu);
  }

  hasMeals() {
    return !_.isNil(this._dailyMenus);
  }

  isSaved() {
    return this.dailyMenus().every(dailyMenu => dailyMenu.isSaved());
  }

  hasSelection() {
    return this.dailyMenus().some(dailyMenu => dailyMenu.hasSelection());
  }

  allAdditionalMealsSelected() {
    return this.dailyMenus().every(dailyMenu => dailyMenu.allAdditionalMealsSelected());
  }

  orders() {
    const menus = this._dailyMenus?.map(this._dailyMenuFor.bind(this)) ?? new Immutable.Map;

    return menus.filter(dm => !dm.isSaved()).map(dm => dm.orders());
  }

  _dailyMenuFor(groupMenus, formattedDate) {
    return new DailyMenuWithOrders(
      this.canteen, moment(formattedDate, dateFormat), groupMenus, this._menu
    );
  }
}
